export var valuesRoseType = ["radius", "area"];
//# sourceMappingURL=RoseType.js.map